import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import NewsRelevant from './NewsRelevant';
import SimilarTags from './SimilarTags';
import NewsPostTitle from './NewsPostTitle';
import NewsPostTags from './NewsPostTags';
import NewsBlock from '../News/NewsBlock';
import DraftRendererWithOptions from '../widgets/DraftRenderer';

import './news-post.scss';
import BlockCompany from '../widgets/StaticRenderer/BlockCompany';

class NewsPostTemplate extends PureComponent {
  render() {
    if (!this.props.post) {
      return null;
    }

    return (
      <div className="news-post">
        <Helmet>
          <title>{this.props.post.title}</title>
          <meta name="description" content={this.props.post.previewText} />

          <meta property="og:title" content={this.props.post.title} />
          <meta property="og:description" content={this.props.post.previewText} />
          <meta property="og:image" content={this.props.post.previewImage} />
        </Helmet>

        <NewsPostTitle
          dateDisplay={this.props.post.dateDisplay}
          titleImage={this.props.post.titleImage}
          title={this.props.post.title}
          pathname={this.props.pathname}
        />

        {(this.props.layout === 'desktop') &&
          <div className="content-wrap">
            <NewsBlock
              pathname={this.props.pathname}
              posts={this.props.posts.results}
              secondaryPost={this.props.posts.secondaryPost}
            />
          </div>
        }

        {(this.props.post.tags && !!this.props.post.tags.length) &&
          <NewsPostTags
            tags={this.props.post.tags}
            pathname={this.props.pathname}
          />
        }

        <DraftRendererWithOptions
          content={JSON.stringify(this.props.post.content)}
        />

        {(!!this.props.post.companyText) &&
          <BlockCompany
            companyLogo={this.props.post.companyLogo}
            companyText={this.props.post.companyText}
          />
        }

        {(this.props.post.tags && !!this.props.post.tags.length) &&
          <SimilarTags
            tags={this.props.post.tags}
            pathname={this.props.pathname}
          />
        }

        {(!!this.props.relevant.length) &&
          <NewsRelevant
            posts={this.props.relevant}
            pathname={this.props.pathname}
          />
        }
      </div>
    );
  }
}

NewsPostTemplate.propTypes = {
  layout: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),
  post: PropTypes.shape({
    dateDisplay: PropTypes.string,
    titleImage: PropTypes.string,
    title: PropTypes.string,
    companyLogo: PropTypes.string,
    companyText: PropTypes.string,
    content: PropTypes.object,
    tags: PropTypes.arrayOf(PropTypes.object)
  }),
  posts: PropTypes.shape({
    primaryPost: PropTypes.object,
    secondaryPost: PropTypes.object,
    results: PropTypes.arrayOf(PropTypes.object),
    searchResults: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  relevant: PropTypes.arrayOf(PropTypes.object),
  pathname: PropTypes.string.isRequired
};

export default NewsPostTemplate;



// WEBPACK FOOTER //
// ./src/components/NewsPost/NewsPostTemplate.js